import React from 'react';

import {Box} from '@famly/mf_layout_box';
import {Text} from '@famly/mf_data-display_text';
import {needsTranslations} from 'web-app/util/scoped-needs-translation';
import {isEmpty} from 'web-app/util/array';

import type * as Types from '../../../types';
import {PlanItem} from './plan-item';

type PlanOverviewProps = {
    planItems: Types.PlanOverview['plans'];
};

const PlanOverview = ({planItems}: PlanOverviewProps) => {
    return (
        <Box mt={5}>
            {isEmpty(planItems) ? (
                <Text variant="body" color="n300" data-e2e-id="empty-state-message">
                    {needsTranslations('SimplifiedUsBilling', 'No plans found')}
                </Text>
            ) : (
                planItems.map((planItem, index) => {
                    return <PlanItem key={planItem.id} plan={planItem} isLast={index === planItems.length - 1} />;
                })
            )}
        </Box>
    );
};

export {PlanOverview};
